import { SUFFIX_SEARCH } from '@/const/app'

// const createState = () => ({
//   handbookApiList: [
//     {
//       api: {},
//       key: '',
//       suffix: ''
//     }
//   ]
// })

const createActions = () => ({
  async createHandbookItemsAndSetDataId ({ state, dispatch }, { data }) {
    for (const handbook of state.handbookApiList) {
      const keyValue = handbook.key + (handbook.suffix || '_id')
      if (data[keyValue]) continue

      const keySearchValue = handbook.key + SUFFIX_SEARCH
      const name = data[keySearchValue]
      if (!name) continue

      const response = await handbook.api.createUnique({ name })
      data[keyValue] = response.data.data.id
    }
  }
})

export const vuexCreateFromSelectSearch = {
  createActions
}
